'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation for the showing an emoji flashing an okay sign.
 */
export function OkayHandEmojiAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('../raw-json/functional-assessment/gestures/ok-hand-emoji.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="OkayHandEmojiAnimation"
    />
  );
}
